import './MapPane.css';

import React from 'react';
import L from 'leaflet';
import { Map, Marker, Popup, TileLayer, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { DeregisterJobObserver, RegisterJobObserver, GetData } from '../Service';

import IconCar from '../assets/car.png';
import IconGreen from '../assets/greenmarker.png';
import IconRed from '../assets/redmarker.png';
import IconGrey from '../assets/greymarker.png';


const MarkerCar = new L.Icon({
    iconUrl: IconCar,
    iconSize: [42, 24],
    iconAnchor: [24, 24],
    popupAnchor: [2, -12]
});

const MarkerGreen = new L.Icon({
    iconUrl: IconGreen,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    tooltipAnchor: [0, 16]
});

const MarkerRed = new L.Icon({
    iconUrl: IconRed,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    tooltipAnchor: [0, 16]
});

const MarkerGrey = new L.Icon({
    iconUrl: IconGrey,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    tooltipAnchor: [0, 16]
});

function updateDrivers(jobs) {
    var drv = [];

    jobs.forEach((element) => {
        var newDrv = {
            'name': element.driverDetail.driverName,
            'lat': element.driverDetail.latitude,
            'lng': element.driverDetail.longitude,
            'id': element.driverNumber
        };

        const found = drv.find(({ id }) => id === newDrv.id);

        var valid;
        if ((element.deliveryDistance || element.pickupDistance) && !(element.deliveryDistance && element.pickupDistance)) {
            valid = true;
        } else {
            valid = false;
        }

        // Perm vehicle override
        if (element.deliverySuburb.trim() === 'VARIOUS') {
            valid = true;
        }

        if (!found && valid) {
            drv.push(newDrv);
        }

    });
    return drv;
}


export class MapPane extends React.Component {

    mapRef; /* Store the reference for the Map component */


    notify = () => {
        console.log("Recieved Map Broadcast");
        GetData().then((data) => {
            this.setState({ jobs: data, loading: false });
            this.setState({ drivers: updateDrivers(this.state.jobs) });
            var box = this.updateDriversCenter(this.state.drivers);
            this.setState({ lat: box.latCenter, lng: box.longCenter });
            this.setState({ zBox: box });
        })
            .catch((error) => { console.error("Failed!", error); });
    }


    getBox() {
        var box = this.state.zBox;
        return [[box.latMin, box.longMin], [box.latMax, box.longMax]];
    }


    getBoxTd = (td) => {
        return [
            [td.driver.location.lat - .2, td.driver.location.long - .2],
            [td.driver.location.lat + .2, td.driver.location.long + .2]
        ];
    }


    constructor() {
        super();
        this.state = {
            lat: -37.815869,
            lng: 144.959721,
            jobs: [],
            drivers: [],
            zBox: this.updateDriversCenter()
        }

        GetData()
            .then((data) => {
                this.setState({ jobs: data, loading: false });
                this.setState({ drivers: updateDrivers(this.state.jobs) });
                var box = this.updateDriversCenter(this.state.drivers);
                this.setState({ lat: box.latCenter, lng: box.longCenter });
                this.setState({ zBox: box });
            })
            .catch((error) => { console.error("Failed!", error); });
    }


    componentDidMount() {
        RegisterJobObserver(this.notify);
    }


    componentWillUnmount() {
        DeregisterJobObserver();
    }


    emitCompletedJobMarkerClicked(jobNumber) {
        if (this.props?.completedJobMarkerClicked) {
            this.props.completedJobMarkerClicked(jobNumber)
        }
    }


    emitLiveJobMarkerClicked(jobNumber) {
        if (this.props?.liveJobMarkerClicked) {
            this.props.liveJobMarkerClicked(jobNumber);
        }
    }


    centerMapByCoordinates(lat, lng) {
        // const currentMapZoom = this.mapRef.leafletElement.getZoom();
        const zoomLevel = 16;
        this.mapRef.leafletElement.flyTo([lat, lng], zoomLevel);
    }


    /**
     * Will try to find the driver marker that matches the provided driverNumber then center the map to it.
     * Will do nothing if no marker matched the provided driverNumber.
     */
    centerMapByDriverNumber(driverNumber) {
        const zoomLevel = 16;
        const driver = this.state?.drivers?.find(driver => driver.id === driverNumber);
        
        if(driver) {
            this.mapRef.leafletElement.flyTo([driver.lat, driver.lng], zoomLevel);
        }
    }


    /**
     * Returns true if the provided coordinates is valid, otherwise returns false.
     * A coordinates is considered INVALID if has 0 lat/lng OR when it has positive lat.
     */
    isCoordinatesValid(lat, lng) {
        let valid = true;
        
        if(!lat || !lng) {
            valid = false;
        }

        if(lat > 0) {
            valid = false;
        }

        return valid;
    }


    updateDriversCenter(drivers) {
        var box = {
            longMin: 0.0,
            longMax: 0.0,
            latMin: 0.0,
            latMax: 0.0,
            longCenter: 0.0,
            latCenter: 0.0
        };

        if (drivers) {
            // Filter out the driver markers with invalid coordinates. We dont want them to be included when calculating for the map bounds.
            const filteredDrivers = drivers.filter(driver => this.isCoordinatesValid(driver.lat, driver.lng));
            
            filteredDrivers.forEach((element) => {
                if (!box.longMin) {
                    box.longMin = element.lng;
                    box.longMax = element.lng;
                    box.latMin = element.lat;
                    box.latMax = element.lat;
                }

                if (box.longMin > element.lng) box.longMin = element.lng;
                if (box.longMax < element.lng) box.longMax = element.lng;
                if (box.latMin > element.lat) box.latMin = element.lat;
                if (box.latMax < element.lat) box.latMax = element.lat;
            });
        }

        box.longCenter = (box.longMin + box.longMax) / 2;
        box.latCenter = (box.latMin + box.latMax) / 2;

        if (box.longCenter === 0.0) box.longCenter = 144.959721;
        if (box.latCenter === 0.0) box.latCenter = -37.81569;

        return box;
    }


    renderLegendContainer() {
        return <div className="legend-container flex flex-column">
            <div className="current flex flex-row gap-2 align-items-center">
                <i className="pi pi-circle-on"></i>
                <div>Current Job</div>
            </div>
            <div className="live flex flex-row gap-2 align-items-center">
                <i className="pi pi-circle-on"></i>
                <div>Live Job</div>
            </div>
            <div className="completed flex flex-row gap-2 align-items-center">
                <i className="pi pi-circle-on"></i>
                <div>Completed Job</div>
            </div>            
        </div>
    }
    
    
    renderRouteCodeDetailsInMarker(leg) {
        if(leg.showRouteCode) {
            return <>
                <div className="flex flex-row gap-1"><b>Route</b><span>{leg.routeCode}</span></div>
                <div className="flex flex-row gap-1"><b>Drop</b><span>{leg.dropNumber}</span></div>
            </>
        }
    }


    renderIncompleteLegMarker(leg, index) {
        // if(this.isCoordinatesValid(leg.lat, leg.long)) {
            return <Marker position={[leg.lat, leg.long]} icon={MarkerRed} key={index} onClick={() => this.emitLiveJobMarkerClicked(leg.iLogixJobNumber)}>
                <Tooltip direction="bottom" offset={[0, 0]} opacity={1} permanent>
                    <div className="flex flex-row gap-1"><b>Job#</b><span>{leg.jobNumber}</span></div>
                    {/*<div className="flex flex-row gap-2"><b>Ref1</b><span>{leg.ref1}</span></div>*/}
                    {/*<div className="flex flex-row gap-2"><b>Ref2</b><span>{leg.ref2}</span></div>*/}
                    {this.renderRouteCodeDetailsInMarker(leg)}
                </Tooltip>
            </Marker>
        // }
    }


    renderCompleteLegMarker(leg, index) {
        if(this.isCoordinatesValid(leg.lat, leg.long)) {
            return <Marker position={[leg.lat, leg.long]} icon={MarkerGrey} key={index} onClick={() => this.emitCompletedJobMarkerClicked(leg.iLogixJobNumber)}>
                <Tooltip direction="bottom" offset={[0, 0]} opacity={1} permanent>
                    <div className="flex flex-row gap-1"><b>Job#</b><span>{leg.jobNumber}</span></div>
                    {/*<div className="flex flex-row gap-2"><b>Ref1</b><span>{leg.ref1}</span></div>*/}
                    {/*<div className="flex flex-row gap-2"><b>Ref2</b><span>{leg.ref2}</span></div>*/}
                    {this.renderRouteCodeDetailsInMarker(leg)}
                </Tooltip>
            </Marker>
        }
    }


    renderDriverMarker(driver) {
        if(this.isCoordinatesValid(driver.location.lat, driver.location.long)) {
            return <Marker position={[driver.location.lat, driver.location.long]} icon={MarkerCar} key="1">
                <Tooltip direction="bottom" offset={[0, 0]} opacity={1} permanent>
                    {driver.name} #{driver.id}
                </Tooltip>
            </Marker>
        }
    }


    renderLegMarker(leg, index) {
        if(this.isCoordinatesValid(leg.location.lat, leg.location.long)) {
            return <Marker position={[leg.location.lat, leg.location.long]} icon={MarkerGreen} key={index}>
                <Popup>
                    <div>
                        <b>{leg.address}</b>
                    </div>
                </Popup>
                <Tooltip direction="bottom" offset={[0, 0]} opacity={1} permanent>
                    {leg.legType}
                </Tooltip>
            </Marker>
        }
    }


    renderDriverMarkerForDashboard(driver, index) {
        if(this.isCoordinatesValid(driver.lat, driver.lng)) {
            return <Marker position={[driver.lat, driver.lng]} icon={MarkerCar} key={index}>
                <Popup>
                    <div>
                        <b>{driver.name}</b>
                    </div>
                </Popup>
                <Tooltip direction="bottom" offset={[0, 0]} opacity={1} permanent>
                    #{driver.id}
                </Tooltip>
            </Marker>
        }
    }


    render() {
        const position = [this.state.lat, this.state.lng];
        const td = this.props.trackingDetails;

        if (td) {
            return (
                <div className="map-pane-component" style={{ height: '100%' }}>
                    {this.renderLegendContainer()}
                    <Map ref={(e) => this.mapRef = e} center={[td.driver.location.lat, td.driver.location.long]} bounds={this.getBoxTd(td)}>
                        <TileLayer
                            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                            url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                        />

                        {td.driver.incompleteLegs.map((leg, index) => (
                            this.renderIncompleteLegMarker(leg, index)
                        ))}

                        {td.driver.completeLegs.map((leg, index) => (
                            this.renderCompleteLegMarker(leg, index)
                        ))}

                        {this.renderDriverMarker(td.driver)}

                        {td.legs.map((leg, index) => (
                            this.renderLegMarker(leg, index)
                        ))}
                    </Map>
                </div>
            );
        }


        else {
            return (
                <div className="map-pane-component" style={{ height: '100%' }}>
                    <Map ref={(e) => this.mapRef = e} center={position} bounds={this.getBox()}>
                        <TileLayer
                            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                            url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                        />
                        {this.state.drivers.map((driver, index) => (
                            this.renderDriverMarkerForDashboard(driver, index)
                        ))}
                    </Map>
                </div>
            );
        }
    }
}